import * as React from "react";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import Grid from "@mui/material/Grid/Grid";
import { useIntl } from "react-intl";
import RemoveIcon from "@mui/icons-material/Remove";
import Button from "@mui/material/Button/Button";
import TextField from "@mui/material/TextField/TextField";
import IconButton from "@mui/material/IconButton/IconButton";
import { styled } from "@mui/material/styles";
import { useFormik, FieldArray, FormikProvider, getIn } from "formik";
import setupProfile from "../../../validation/setup-profile";
import { AuthUserContext } from "../../../providers/AuthProvider";
import firebase from "../../../firebase/firebase";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../../components/TopBarV2";
import Avatar from "@mui/material/Avatar/Avatar";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { CloseOutlined, Delete, PlayCircle,} from "@mui/icons-material";
import {  Modal } from "@mui/material";
import AlertDialog from "../../../components/AlertDialog";
import PostActivity from "../../../helpers/post-activity";
import Spinner from "../../../components/spinner";
import ImageIcon from '@mui/icons-material/Image';

export default function WorkHistory({ parentCallback, view }) {
	const [another,setAnother]=React.useState(false);

	const videoExt = /.mp4|.ogg|.webm|.mkv|.mov/
	const [mediaSelected, setMediaSelected] = React.useState("")
	const [videoPopup, setVideoPopup]= React.useState(false)
	const storageRef = firebase.storage().ref();
	const { user, profile } = React.useContext(AuthUserContext);
	const [disabled, setDisabled] = React.useState(false);
	const [workHistories, setWorkHistories] = React.useState();
	const [mode, setMode] = React.useState(view);
	const navigator = useNavigate();
	const Input = styled("input")({
		display: "none",
	});
	const uploadFile = (folder, document) => {
		return new Promise((resolve, reject) => {
			const file = document;
			const path = `profiles/${profile?.uid}/${folder}/${file.name}`;
			const uploadTask = storageRef.child(path).put(file);

			uploadTask.on(
				"state_changed",
				(snapshot) => {
					var progress =
						(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					console.log("Upload is " + progress + "% done");
					switch (snapshot.state) {
						case firebase.storage.TaskState.PAUSED: // or 'paused'
							console.log("Upload is paused");
							break;
						case firebase.storage.TaskState.RUNNING: // or 'running'
							console.log("Upload is running");
							break;
					}
				},
				(error) => {
					reject(error);

					// Handle unsuccessful uploads
				},
				() => {
					resolve(path);
				}
			);
		});
	};

	const formik = useFormik({
		initialValues: workHistories || setupProfile.WorkHistoryInitialValues,
		validationSchema: setupProfile.WorkHistorySchema,
		onSubmit: async (values) => {
			window.scrollTo(0, 470);
			setDisabled(true);
			const mainProjects = [];
			if (values.projects.length > 0) {
				for (let x of values.projects) {
					const p = { ...x };
					if (x.document) {
						if (x.document !== '') {
							const document = await uploadFile(
								"main-project/cover",
								p.document
							);
							p.cover = document;
							delete p.document;
							delete p.src;
						}

					}
					const mediaFiles = [];

					if (x.mediaFiles && x.mediaFiles.length > 0) {
						for (let m of x.mediaFiles) {
							if (m.document && m.document !== '') {
								const url = await uploadFile(
									"main-project/media-files",
									m.document
								);
								mediaFiles.push(url);
							}else {
								mediaFiles.push(m.url)
							}
						}
					}

					if(mediaFiles.length!==0)
					{p.mediaFiles.concat(...mediaFiles);}

					mainProjects.push({ ...p, mediaFiles });
				}
			}
			debugger
			const postData = {
				mainProjects :[...mainProjects],
				...values,
			};
			delete postData["projects"];
			const userRef = firebase
				.firestore()
				.collection("users")
				.doc(profile.id);
			const userDoc = await userRef.update({
				workHistory: postData,
			});

			setDisabled(false);
			setMode('self')
			await PostActivity({
				text: 'Your profile is all set up.',
				uid: profile.uid,
				createdBy:profile?.uid
			})
			// parentCallback("interests");
		},
	});
	const downloadURL = (url) =>
		new Promise((resolve, reject) => {
			const mediaRef = storageRef.child(url);

			// Get the download URL
			mediaRef
				.getDownloadURL()
				.then((url) => {
					resolve(url);
				})
				.catch((error) => {
					resolve('error');
					// setLoading(false)

					// A full list of error codes is available at
					// https://firebase.google.com/docs/storage/web/handle-errors
					switch (error.code) {
						case "storage/object-not-found":
							// File doesn't exist
							break;
						case "storage/unauthorized":
							// User doesn't have permission to access the object
							break;
						case "storage/canceled":
							// User canceled the upload
							break;

						// ...

						case "storage/unknown":
							// Unknown error occurred, inspect the server response
							break;
					}
				});
		});
	useEffect(() => {
		const userRef = firebase
			.firestore()
			.collection("users")
			.doc(profile.id);
		userRef.get().then(async (u) => {
			if (u.data().workHistory && u.data().workHistory.biography) {
				let setObject = {};

				if (u.data().workHistory.mainProjects) {

					setObject = {
						...u.data().workHistory,
						projects: u.data().workHistory.mainProjects,
					};

					for (let index = 0; index < setObject.projects.length; index++) {
						if(setObject.projects[index].cover){
							const url =  await downloadURL(setObject.projects[index]?.cover)
							// setObject.projects[index].cover =url;
							setObject.projects[index].src= url;
							setObject.projects[index].document = '';
							setObject.projects[index].progress = 100;
						}
						for (let j = 0; j < setObject.projects[index].mediaFiles.length; j++) {
							setObject.projects[index].mediaFiles[j] = {
								src: await downloadURL(setObject.projects[index].mediaFiles[j]),
								document: '',
								progress: 100,
								url: setObject.projects[index].mediaFiles[j]
							}
						}
					}


					// console.log(setObject);
					delete setObject.mainProjects;
				}
				formik.setValues({...setObject});
				setWorkHistories({...setObject});
				if (!mode) setMode('self')
			} else {

				setMode("edit");
			}
		});
	}, [mode]);
	return (
		<>
			{/* Hero unit */}
			<Container
				maxWidth="md"
				component="main"
				sx={{ my: 5, textAlign: "left"}}>
				{disabled && <Spinner></Spinner>}		
				<Grid container sx={{display: disabled?"none" :"flex"}}>
					<Grid item xs={12}>
						<FormikProvider value={formik}>
							<Stack
								sx={{
									display: "flex",
									alignItems: "flex-end",
								}}>
								{mode === "self" && (
									<Button
										onClick={(e) => setMode("edit")}
										sx={{fontFamily: "ABeeZee", py: 0.5, px: 5, width: "25%", textTransform: "none"}}
										variant={"outlined"}
										startIcon={
											<img
												src={
													"/assets/icons/pencil-edit.png"
												}
											/>
										}>
										Edit info
									</Button>
								)}
							</Stack>
							<Stack
								direction={"column"}
								component={"form"}
								onSubmit={formik.handleSubmit}
								spacing={3}>
								<span />

								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{ borderBottom: "1px solid #204488" }}>
									BIOGRAPHY
								</Typography>
								{mode === "edit" ? (
									<>
									<TextField
										value={formik.values.biography}
										onChange={formik.handleChange}
										error={
											formik.touched.biography &&
											Boolean(formik.errors.biography)
										}
										helperText={
											formik.touched.biography &&
											formik.errors.biography
										}
										name="biography"
										label="Description about yourself."
										fullWidth
										multiline
										rows={7}
										// inputProps={{maxLength:500}}
									/>
									{/* <Typography align="right" sx={{color:"#818488"}}>{500-formik.values.biography.length}/500</Typography> */}
									</>
								) : (
									<Typography
										sx={{
											fontWeight: "500",
											fontSize: "16px",
											lineHeight: "30px",
											color: "#363636",
										}}>
										{formik.values.biography}
									</Typography>
								)}
								<span />
								<span />

								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{ borderBottom: "1px solid #204488" }}>
									WORK EXPERIENCE
								</Typography>

								<FieldArray
									name={"experiences"}
									render={(arrayHelpers) => {
										return (
											<>
												{arrayHelpers?.form.values.experiences.map(
													(cast, i) => (
														<>
															{mode === "edit" ? (
																<>
																	{arrayHelpers?.form.values.experiences.length > 1 && <Button
																		variant={"outlined"}
																		onClick={() => {
																			arrayHelpers.remove(i)
																		}}
																		sx={{
																			borderRadius: 0,
																			ml: 2,
																			width: 150,
																			height: 35


																		}}
																		style = {{ marginLeft : "82%"}}
																		size={"small"}
																		startIcon={<RemoveIcon/>}>
																		Remove
																	</Button>}
																	<TextField
																		label={
																			"Work title"
																		}
																		name={`experiences.${i}.title`}
																		value={
																			formik
																				.values
																				.experiences[
																				i
																			]
																				.title
																		}
																		onChange={
																			formik.handleChange
																		}
																		error={

																			getIn(formik.touched, `experiences.${i}.title`)
																			&& getIn(formik.errors, `experiences.${i}.title`)

																		}
																		helperText={
																			getIn(formik.touched, `experiences.${i}.title`)
																			&& getIn(formik.errors, `experiences.${i}.title`)&&
																			formik
																				.errors
																				.experiences[
																				i
																			]
																				.title
																		}
																	/>
																	<Stack
																		direction="row"
																		justifyContent="flex-start"
																		alignItems="center"
																		spacing={
																			3
																		}>
																		<TextField
																			label={
																				"Start date"
																			}
																			type={
																				"date"
																			}
																			fullWidth
																			InputLabelProps={{
																				shrink: true,
																			}}
																			inputProps={{
																				max: "2050-01-01",
																				min: "1980-01-01",
																			}}
																			name={`experiences.${i}.startDate`}
																			value={
																				formik
																					.values
																					.experiences[
																					i
																				]
																					.startDate
																			}
																			onChange={
																				formik.handleChange
																			}
																			error={
																				getIn(formik.touched, `experiences.${i}.startDate`)
																				&& getIn(formik.errors, `experiences.${i}.startDate`)

																			}
																			helperText={
																				getIn(formik.touched, `experiences.${i}.startDate`)
																				&& getIn(formik.errors, `experiences.${i}.startDate`) &&
																				formik
																					.errors
																					.experiences[
																					i
																				]
																					.startDate
																			}
																		/>
																		<TextField
																			label={
																				"End date"
																			}
																			type={
																				"date"
																			}
																			fullWidth
																			InputLabelProps={{
																				shrink: true,
																			}}
																			inputProps={{
																				max: "2050-01-01",
																				min: "1980-01-01",
																			}}
																			name={`experiences.${i}.endDate`}
																			value={
																				formik
																					.values
																					.experiences[
																					i
																				]
																					.endDate
																			}
																			onChange={
																				formik.handleChange
																			}
																			error={
																				getIn(formik.touched, `experiences.${i}.endDate`)
																				&& getIn(formik.errors, `experiences.${i}.endDate`)
																			}
																			helperText={
																				getIn(formik.touched, `experiences.${i}.endDate`)
																				&& getIn(formik.errors, `experiences.${i}.endDate`) &&
																				formik
																					.errors
																					.experiences[
																					i
																				]
																					.endDate
																			}
																		/>
																	</Stack>
																	<TextField
																		name={`experiences.${i}.description`}
																		// inputProps={{maxLength:500}}
																		value={
																			formik
																				.values
																				.experiences[
																				i
																			]
																				.description
																		}
																		onChange={
																			formik.handleChange
																		}
																		error={
																			getIn(formik.touched, `experiences.${i}.description`)
																			&& getIn(formik.errors, `experiences.${i}.description`)
																		}
																		helperText={
																			getIn(formik.touched, `experiences.${i}.description`)
																			&& getIn(formik.errors, `experiences.${i}.description`) &&
																			formik
																				.errors
																				.experiences[
																				i
																			]
																				.description
																		}
																		label="Description of the work experience"
																		fullWidth
																		multiline
																		rows={7}
																	/>
																	{/* <Typography align="right" sx={{color:"#818488"}}>{500-formik.values.experiences[i].description.length}/500</Typography> */}
																	{/* {arrayHelpers?.form.values.experiences.length > 1 && <Button
																		variant={"outlined"}
																		onClick={() => {
																			arrayHelpers.remove(i)
																		}}
																		sx={{
																			borderRadius: 0,
																			ml: 2,
																			width: 150,
																			height: 35


																		}}
																		size={"small"}
																		startIcon={<RemoveIcon/>}>
																		Remove
																	</Button>} */}
																</>
															) : (
																<>
																	<Box
																		sx={{
																			display:
																				"flex",
																			flexDirection:
																				"row",
																		}}>
																		<Stack
																			sx={{
																				color: "#204488",
																				fontWeight:
																					"600",
																				fontSize:
																					"16px",
																			}}
																			width={
																				"10%"
																			}>
																			{
																				formik.values.experiences[
																					i
																				].startDate.split(
																					"-"
																				)[0]
																			}
																		</Stack>
																		<Stack
																			width={
																				"90%"
																			}
																			direction={
																				"column"
																			}
																			spacing={
																				2
																			}>
																			<Typography
																				sx={{
																					color: "#204488",
																					fontWeight:
																						"600",
																					fontSize:
																						"16px",
																				}}>
																				{
																					formik
																						.values
																						.experiences[
																						i
																					]
																						.title
																				}
																			</Typography>
																			<Typography
																				sx={{
																					textAlign:
																						"justify",
																					fontWeight:
																						"500",
																					fontSize:
																						"16px",
																					lineHeight:
																						"30px",
																					color: "#363636",
																				}}>
																				{
																					formik
																						.values
																						.experiences[
																						i
																					]
																						.description
																				}
																			</Typography>

																		</Stack>
																	</Box>
																</>
															)}
															<span />
															<span />
														</>
													)
												)}
												{mode === "edit" && (
													<Stack direction="row" spacing={2}>
													<Button
														onClick={() => {
															// console.log('work experience add another clicked', arrayHelpers.form.values.experiences.length)
															arrayHelpers.push({
																id: Math.random(),
																title: "",
																description: "",
																startDate: "",
																endDate: "",
															});
														}}
														variant={"outlined"}
														sx={{
															borderRadius: 0,
															width: 150,
														}}
														size={"small"}
														startIcon={<AddIcon />}>
														Add another
													</Button>
											{/*		{*/}
											{/*			arrayHelpers.form.values.experiences.length > 1 ? <>*/}
											{/*			<Button*/}
											{/*	variant={"outlined"}*/}
											{/*	onClick={() => {*/}
											{/*				arrayHelpers.pop()*/}
											{/*			}}*/}
											{/*	sx={{*/}
											{/*		borderRadius: 0,*/}
											{/*		ml: 2,*/}
											{/*		width: 150,*/}
											{/*		height:35*/}
											{/*		*/}
											{/*	*/}
											{/*	}}*/}
											{/*	size={"small"}*/}
											{/*	startIcon={<RemoveIcon />}>*/}
											{/*	Remove*/}
											{/*</Button>*/}
											{/*			</>: <></>*/}
											{/*		}*/}


													</Stack>
												)}
												
											</>
										);
									}}
								/>
								{profile?.userType === "artist" || profile?.userType === "creator"?
								(
									mode === "edit" ?
									(<>
										{" "}
										<span />
										<TextField
											value={formik.values.linkdenURL}
											onChange={formik.handleChange}
											onBlur={(e) => {
												const value = e.target.value
												if (value !== '') {
													const checkValid = /https:\/\/|http:\/\//
													if (!checkValid.test(value)) formik.setFieldValue('linkdenURL', 'https://'+ value)
												}
											}}
											error={
												formik.touched.linkdenURL &&
												Boolean(
													formik.errors.linkdenURL
													)
												}
												helperText={
													formik.touched.linkdenURL &&
													formik.errors.linkdenURL
												}
												name="linkdenURL"
												label="Add LinkedIn URL"
												fullWidth
												/>
										<TextField
											value={formik.values.portfolioURL}
											onChange={formik.handleChange}
											onBlur={(e) => {
												const value = e.target.value
												if (value !== '') {
													const checkValid = /https:\/\/|http:\/\//
													if (!checkValid.test(value)) formik.setFieldValue('portfolioURL', 'https://'+ value)
												}
											}}

											error={
												formik.touched.portfolioURL &&
												Boolean(
													formik.errors.portfolioURL
													)
												}
												helperText={
													formik.touched.portfolioURL &&
													formik.errors.portfolioURL
												}
												name="portfolioURL"
												label="Portfolio link"
												fullWidth
												/>
										<span />
									</>)
									:
									(<>
										{formik.values.linkdenURL &&
										<a style={{ color: "#204488",fontSize: "16px",fontWeight:"550"}} href={formik.values.linkdenURL}>Link to LinkedIn Profile</a>
										}
										{formik.values.portfolioURL &&
										<a style={{color: "#204488", fontSize: "16px",fontWeight:"550"}} href={formik.values.portfolioURL}>Link to Portfolio</a>
										}
									</>)
								) : (
									<>
										<span />
										<span />
									</>
								)}

								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{ borderBottom: "1px solid #204488"}}>
									MAIN PROJECTS
								</Typography>

								<FieldArray
									name={"projects"}
									render={(arrayHelpers) => {
										return (
											<>
												{arrayHelpers?.form.values.projects.map(
													(cast, i) => (
														<>
															{mode === "edit" ? (
																<>
																{arrayHelpers?.form.values.projects.length > 1 && <Button
																		variant={"outlined"}
																		onClick={() => {
																			arrayHelpers.remove(i)
																		}}
																		sx={{
																			borderRadius: 0,
																			ml: 2,
																			width: 150,
																			height: 35

																		}}
																		style = {{ marginLeft : "82%"}}
																		size={"small"}
																		startIcon={<RemoveIcon/>}>
																		Remove
																	</Button>}
																	<Stack
																		direction={{
																			md: "row",
																			sm: "column",
																		}}
																		justifyContent="flex-start"
																		alignItems="center"
																		spacing={
																			3
																		}>
																		<Stack
																			direction={
																				"column"
																			}
																			justifyContent="center"
																			alignItems="center"
																			sx={{
																				width: "150px",
																				height: 141,
																				border: "1px solid #ccc",
																			}}
																			spacing={
																				2
																			}>
																			<label
																				htmlFor={`projects-${i}`}>
																				{arrayHelpers
																					.form
																					.values
																					.projects[
																					i
																				]
																					?.src ? (
																					<Avatar
																						alt={
																							"Tabain"
																						}
																						src={
																							arrayHelpers
																								.form
																								.values
																								.projects[
																								i
																							]
																								?.src
																						}
																						sx={{
																							width: "150px",
																							height: 141,
																							cursor: "pointer",
																							borderRadius:
																								"0px",
																						}}
																						imgProps={{
																							sx: {
																								objectFit:
																									"cover",
																							},
																						}}
																						component={
																							"span"
																						}
																					/>
																				) : (
																					<Button
																						component={
																							"span"
																						}>
																						<Stack
																							direction={
																								"column"
																							}>
																							<img
																								src="/assets/icons/profile-project-cover-icon.png"
																								alt=""
																								style={{
																									margin: "auto",
																									display:
																										"block",
																								}}
																							/>
																							<Typography
																								variant={
																									"body2"
																								}>
																								Project
																								cover
																							</Typography>
																						</Stack>
																					</Button>
																				)}
																				<Input
																					accept="image/*"
																					id={`projects-${i}`}
																					multiple={
																						false
																					}
																					type="file"
																					onChange={(
																						e
																					) => {
																						const fileReader = new FileReader();
																						fileReader.readAsDataURL(e.target.files[0]);
																						fileReader.addEventListener(
																							"load",
																							async function () {
																								arrayHelpers.replace(
																									i,
																									{
																										...arrayHelpers
																											.form
																											.values
																											.projects[i],
																										src: this.result,
																										document: e.target.files[0],
																										progress: 0,
																									}
																								);
																							}
																						);
																					}}
																				/>
																			</label>
																		</Stack>
																		<Stack
																			direction={
																				"column"
																			}
																			sx={{
																				width: "100%",
																				
																			}}
																			spacing={
																				3
																			}>
																			<TextField  
																				label={
																					"Project title"
																				}
																				name={`projects.${i}.title`}
																				value={
																					formik
																						.values
																						.projects[
																						i
																					]
																						.title
																				}
																				onChange={
																					formik.handleChange
																				}
																				error={
																					getIn(formik.touched, `projects.${i}.title`)
																					&& getIn(formik.errors, `projects.${i}.title`)
																				}
																				helperText={
																					getIn(formik.touched, `projects.${i}.title`)
																					&& getIn(formik.errors, `projects.${i}.title`) &&
																					formik
																						.errors
																						.projects[
																						i
																					]
																						.title
																				}
																			/>
																			<TextField
																				label={
																					"Your role"
																				}
																				name={`projects.${i}.role`}
																				value={
																					formik
																						.values
																						.projects[
																						i
																					]
																						.role
																				}
																				onChange={
																					formik.handleChange
																				}
																				error={
																					getIn(formik.touched, `projects.${i}.role`)
																					&& getIn(formik.errors, `projects.${i}.role`)
																				}
																				helperText={
																					getIn(formik.touched, `projects.${i}.role`)
																					&& getIn(formik.errors, `projects.${i}.role`) &&
																					formik
																						.errors
																						.projects[
																						i
																					]
																						.role
																				}
																			/>
																		</Stack>
																	</Stack>

																	<TextField
																		label={
																			"IMDb link to project"
																		}
																		name={`projects.${i}.imdb`}
																		value={
																			formik
																				.values
																				.projects[
																				i
																			]
																				.imdb
																		}
																		onChange={
																			formik.handleChange
																		}
																		onBlur={(e) => {
																			const value = e.target.value
																			if (value !== '') {
																				const checkValid = /https:\/\/|http:\/\//
																				if (!checkValid.test(value)) formik.setFieldValue(`projects.${i}.imdb`, 'https://'+ value)
																			}
																		}}
																		error={
																			getIn(formik.touched, `projects.${i}.imdb`)
																			&& getIn(formik.errors, `projects.${i}.imdb`)
																		}
																		helperText={
																			getIn(formik.touched, `projects.${i}.imdb`)
																			&& getIn(formik.errors, `projects.${i}.imdb`)&&
																			formik
																				.errors
																				.projects[
																				i
																			]
																				.imdb
																		}
																	/>

																	<TextField
																		name={`projects.${i}.description`}
																		// inputProps={{maxLength:500}}
																		value={
																			formik
																				.values
																				.projects[
																				i
																			]
																				.description
																		}
																		onChange={
																			formik.handleChange
																		}
																		error={
																			getIn(formik.touched, `projects.${i}.description`)
																			&& getIn(formik.errors, `projects.${i}.description`)
																		}
																		helperText={
																			getIn(formik.touched, `projects.${i}.description`)
																			&& getIn(formik.errors, `projects.${i}.description`) &&
																			formik
																				.errors
																				.projects[
																				i
																			]
																				.description
																		}
																		label="Description of the Project"
																		fullWidth
																		multiline
																		rows={7}
																	/>
																	{/* <Typography align="right" sx={{color:"#818488"}}>{500-formik.values.projects[i].description.length}/500</Typography> */}
																	<Typography
																		variant={
																			"body2"
																		}>
																		Add
																		media
																		related
																		to the
																		project
																	</Typography>
																	<Stack
																		direction={{
																			md: "row",
																			sx: "column",
																		}}
																		justifyContent="flex-start"
																		alignItems="flex-start"
																		spacing={
																			3
																		}>
																		<Stack
																			sx={{
																				height: 128,
																				width: 128,
																				borderRadius:
																					"10px",
																				border: "1px solid #ccc",
																			}}
																			direction={
																				"column"
																			}
																			justifyContent="center"
																			alignItems="center">
																			<label
																				htmlFor={`mediaFiles-${i}`}>
																				<Button
																					component={
																						"span"
																					}>
																					<img
																						src="/assets/icons/profile-project-cover-icon.png"
																						alt=""
																					/>
																				</Button>
																				<Input
																					accept="image/*,video/*"
																					id={`mediaFiles-${i}`}
																					multiple={
																						true
																					}
																					type="file"
																					onChange={async ( e) => {
																						let mediaFiles
																						if(arrayHelpers.form.values.projects[i].mediaFiles)
																						{mediaFiles = arrayHelpers.form.values.projects[i].mediaFiles}
																						else{
																							mediaFiles=[]
																						};
																						for ( let q = 0; q < e.target.files.length; q++
																						) {
																							const file = e.target.files.item(q);
																							const fileReader = new FileReader();
																							fileReader.readAsDataURL( file);
																							fileReader.addEventListener(
																								"load",
																								async function () {
																									mediaFiles.push(
																										{ src: this.result,
																											document: file,
																											progress: 0,
																										}
																									);
																									if ( q === e.target.files.length - 1 ) {
																										arrayHelpers.replace(
																											i,
																											{
																												...arrayHelpers
																													.form
																													.values
																													.projects[
																													i
																												],
																												mediaFiles,
																											}
																										);
																									}
																								}
																							);
																						}
																					}}
																				/>
																			</label>
																		</Stack>
																		{
																		arrayHelpers.form.values.projects[i].mediaFiles &&
																		arrayHelpers.form.values.projects[i].mediaFiles.length >0 &&
																		arrayHelpers.form.values.projects[i].mediaFiles.filter(d => d.src !== undefined ).map((d, ind) => {
																			// console.log(
																			// 			d
																			// 		);
																					return (
																					<div className="project-container">
																					{!disabled &&
																					<div className="overlay">
																						<Delete className="delete-media"
																						onClick={()=>{
																							// console.log(arrayHelpers.form.values.projects[i].mediaFiles.filter(v=> v.src === d.src))
																							const mediaFiles = [...arrayHelpers.form.values.projects[i].mediaFiles]
																							mediaFiles.splice(ind, 1)
																							debugger
																							// const mediaFiles= arrayHelpers.form.values.projects[i].mediaFiles.filter(v=> v.document !== d.document)
																							arrayHelpers.replace(i,
																								{
																									...arrayHelpers
																									.form
																									.values
																									.projects[
																										i
																									],
																									mediaFiles,

																								}
																								)
																								// arrayHelpers.remove(i.mediaFiles[d])
																							}}
																							/></div>
																						}
																					{d.document !== '' && d.document.type.split("/")[0]==="image" ?
																						<img	className="project-media"
																								src={
																									d?.src }
																								style={{
																									width: 128,
																									height: 128,

																									objectFit:
																										"cover",
																									borderRadius:
																										"10px",

																								}}
																								alt={
																									d
																										?.document
																										?.name
																								}
																						/> : d.url && !videoExt.test(d.url ) &&
																						<img	className="project-media"
																								src={
																									d?.src }
																								style={{
																									width: 128,
																									height: 128,

																									objectFit:
																										"cover",
																									borderRadius:
																										"10px",

																								}}

																						/>

																							}
																					{ d.document !== '' && d.document.type.split("/")[0]==="video" ?

																						<video 
																						src={d?.src}
																						style={{
																							width: 128,
																							height: 128,
																							objectFit:"cover",
																							borderRadius:"10px",}}
																							/> :
																						d.url && videoExt.test(d.url ) &&
																						<video
																							src={d?.src}
																							style={{
																								width: 128,
																								height: 128,
																								objectFit:"cover",
																								borderRadius:"10px",}}
																						/>
																						}		
																					</div>

																			);
																		})
																	}
																	</Stack>
																	{/* {arrayHelpers?.form.values.projects.length > 1 && <Button
																		variant={"outlined"}
																		onClick={() => {
																			arrayHelpers.remove(i)
																		}}
																		sx={{
																			borderRadius: 0,
																			ml: 2,
																			width: 150,
																			height: 35


																		}}
																		size={"small"}
																		startIcon={<RemoveIcon/>}>
																		Remove
																	</Button>} */}
																</>
															) : (
																<>
																	<Box
																		sx={{
																			display:
																				"flex",
																			flexDirection:
																				"row",
																			pb: 5,
																		}}>
																		<Stack
																			sx={{

																				color: "#204488",
																				fontWeight:
																					"500",
																				fontSize:
																					"22px",
																			}}
																			width={
																				"30%"
																			}>
																			{
																				formik
																					.values
																					.projects[
																					i
																				]
																					.title
																			}
																			{
																				formik.values.projects[i].src ? 
																					<img
																					style={{marginTop:"10px"}}
																					src={formik.values.projects[i].src}
																					alt="Project Cover">
																					</img> : <ImageIcon
																					style={{marginTop:"10px" , color: "#204488" , width: 150, height: 175}}
																					></ImageIcon>
																			}
																			
																		</Stack>
																		<Stack
																			width={
																				"70%"
																			}
																			direction={
																				"column"
																			}
																			spacing={
																				4
																			}>
																			<Typography
																				sx={{
																					color: "#204488",
																					fontWeight:
																						"500",
																					fontSize:
																						"16px",
																						marginLeft:"50px",
																						marginTop:"50px"
																				}}>
																				Description
																				<br></br>
																				<Typography
																				sx={{

																					fontWeight:
																						"500",
																					fontSize:
																						"16px",
																					lineHeight:
																						"30px",
																					color: "#363636",

																				}}>
																				{
																					formik
																						.values
																						.projects[
																						i
																					]
																						.description
																				}
																			</Typography>
																			</Typography>

																			<Stack
																				sx={{
																					display:
																						"flex",
																					width: "20%",
																					flexDirection:
																						"row",
																					lineHeight:
																						"30px",
																					justifyContent:
																						"space-between",

																				}}>
																				<Typography
																					sx={{

																						color: "#204488",
																						fontWeight:
																							"500",
																						fontSize:
																							"16px",
																							marginLeft:"50px"

																					}}>
																					Role

																				</Typography>
																				<Typography
																					sx={{
																						marginLeft:"50px",
																						textAlign:
																							"justify",
																						fontWeight:
																							"500",
																						fontSize:
																							"16px",
																						color: "#363636",
																					}}>
																					{
																						formik
																							.values
																							.projects[
																							i
																						]
																							.role
																					}
																				</Typography>
																			</Stack>
																			{formik.values.projects[i].imdb && (
																			<Stack sx={{
																					display:
																						"flex",
																					width: "30%",
																					flexDirection:
																						"row",
																					lineHeight:
																						"30px",
																					justifyContent:
																						"space-between",
																						

																				}}>
																					<a style={{color: "#204488", fontSize: "16px",marginLeft:"50px",fontWeight:"550"}} href={formik
																				.values
																				.projects[
																				i
																			]
																				.imdb} target="_blank">Link to IMDb</a>


																			</Stack>
																			)}
																		</Stack>
																	</Box>
																	
																	<Stack
																		sx={{
																			color: "#204488",
																			fontWeight:
																				"500",
																			fontSize:
																				"22px",
																		}}
																		>
																		Media
																		Gallery
																		<br></br>	<br></br>
																		<Stack direction={{
																			md: "row",
																			sx: "column",
																		}}
																		justifyContent="flex-start"
																		alignItems="center"
																		spacing={
																			3
																		}>

																		{arrayHelpers.form.values.projects[i].mediaFiles &&
																		arrayHelpers.form.values.projects[i].mediaFiles.length >0 &&
																		arrayHelpers.form.values.projects[i].mediaFiles.map
																		((d) => (
														
																			videoExt.test(d.url || d) ?
																			<>
																			<div className="project-container">
																			<div className="video-overlay" style={{display:"flex", cursor:"pointer", justifyContent:"center", alignItems:"center"}}>
																				<PlayCircle fontSize={'large'} sx={{position:"absolute", zIndex:5, color:"#37474F", borderRadius:"100%", backgroundColor:"#ffffff"}}
																				onClick={()=>{
																					setMediaSelected(d)
																					setVideoPopup(true)
																				}}/>
																			</div>
																			<video src={d}
																			style={{width: 128,
																				height: 128,
																				objectFit:"cover",
																				borderRadius:"10px",
																				border: "1px solid #ccc",
																			}}
																			alt={d?.document?.name}
																			
																			/>
																			</div>
																			</>
																					:
																			<div>

																			<img
																			onClick={()=>{
																				setMediaSelected(d)
																				setVideoPopup(true)
																			}}
																			src={
																				d.src
																			}
																			style={{
																				cursor:"pointer",
																				width: 128,
																				height: 128,
																				objectFit:
																				"cover",
																				borderRadius:
																				"10px",
																				border: "1px solid #ccc",
																			}}
																			alt={
																				d
																				?.document
																				?.name
																			}
																			>
																							</img>
																				</div>
																				)
																				)}
																		</Stack>
																	</Stack>
																	
																</>
															)}
															<span />
															<span />
														</>
													)
												)}
												{mode === "edit" && (
													<Stack direction="row" spacing={2}>
													<Button
														onClick={() => {
															arrayHelpers.push({
																id: Math.random(),
																title: "",
																description: "",
																role: "",
																imdb: "",
															});
														}}
														variant={"outlined"}
														sx={{
															borderRadius: 0,
															
														
															width: 150,
														}}
														size={"small"}
														startIcon={<AddIcon />}>
														Add another
													</Button>
											{/*		{*/}
											{/*			arrayHelpers.form.values.projects.length > 1 ? <>*/}
											{/*			<Button*/}
											{/*			onClick={() => {*/}
											{/*				arrayHelpers.pop();*/}
											{/*			}}*/}
											{/*	variant={"outlined"}*/}
											{/*	sx={{*/}
											{/*		borderRadius: 0,*/}
											{/*		ml: 2,*/}
											{/*		width: 150,*/}
											{/*		height:35*/}
											{/*		*/}
											{/*	*/}
											{/*	}}*/}
											{/*	size={"small"}*/}
											{/*	startIcon={<RemoveIcon />}>*/}
											{/*	Remove*/}
											{/*</Button>*/}
											{/*			</>: <></>*/}
											{/*		}*/}
													</Stack>
												)}
											</>
										);
									}}
								/>
								{mode === "edit" && (
									<Stack
										spacing={2}
										direction="row"
										sx={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}>
										<Button
											sx={{
												pt: 1.2,
												pb: 1.2,
												pl: 5,
												pr: 5,
												textDecoration: "underline",
											}}
											onClick={() => setMode("self")}>
											Quit without saving{" "}
										</Button>

										<Button
											variant="contained"
											sx={{
												pt: 1.2,
												pb: 1.2,
												pl: 5,
												pr: 5,
												backgroundColor: "#FD4A01",
											}}
											color={"warning"}
											type={"submit"}
											disabled={disabled}>
											{disabled ? "Saving" : "Save Changes"}
										</Button>
									</Stack>
								)}
							</Stack>
						</FormikProvider>
					</Grid>
				</Grid>
			</Container>
										
			<Modal open={videoPopup} maxWidth='xl' sx={{color: "#ECF3FF",}}>
				<Box sx={{ position: 'absolute',
							maxHeight:"80vh",
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)',}}>

          			<IconButton sx={{position:"absolute", zIndex:5, right:"10px",maxHeight:"5vh", maxWidth:"5vh"}} color={"primary"} onClick={() => {setVideoPopup(false); setMediaSelected("")}}>
            			<CloseOutlined fontSize="large" sx={{color:"#FFFFFF", borderRadius:"100%", maxHeight:"5vh",maxWidth:"5vh", boxShadow: "rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px"}}/>
					</IconButton>
					{mediaSelected && 
					(videoExt.test(mediaSelected.src)?
					<video controls
					style={{maxHeight:"80vh"}}
					src={mediaSelected.src}/>
					:
				    <img src={mediaSelected.src} alt={'Media'}
					style={{maxHeight:"80vh"}}></img>
					)}
				</Box>
			</Modal>
		</>
	);
}
